import React, { useImperativeHandle, useRef, useState } from "react";
import classes from "./Input.module.scss";

interface Props {
  id: string;
  type: string;
  minLength?: number;
  maxLength?: number;
  placeholder?: string;
  classes?: string;
  value?: string;
  readonly?: boolean;
  autocomplete?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // ✅ add this
}

interface IImperativeHandler {
  focus: () => void;
  value?: string;
}

const Input = React.forwardRef<IImperativeHandler, Props>((props, ref) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState(props.value || "");

  function inputChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.currentTarget.value);

    // ✅ call parent onChange if provided
    if (props.onChange) {
      props.onChange(e);
    }
  }

  function inputFocused() {
    inputRef.current?.focus();
    inputRef.current?.setAttribute("style", "border:2px solid red");
  }

  useImperativeHandle(ref, () => {
    return {
      focus: inputFocused,
      value: value,
    };
  });

  return (
    <div className={`${classes.form__control} ${props.classes || ""}`}>
      <label htmlFor={props.id}>{props.id}</label>
      <input
        ref={inputRef}
        id={props.id}
        minLength={props.minLength}
        maxLength={props.maxLength}
        type={props.type}
        placeholder={props.placeholder}
        value={value}
        readOnly={props.readonly || false}
        onChange={inputChangeHandler} // ✅ internal + external
        autoComplete={props.autocomplete || "off"}
      />
    </div>
  );
});

export default Input;
